import '../styles/studentResponsive.css';
import { palette } from '../theme/designSystem';
/* --- File: src/layouts/MainLayout.js (UPGRADED v3.0) --- */
import React, { useState, useEffect, useMemo, useRef } from 'react';
import AiLogo from '../components/AiLogo';
import '../styles/lightPages.css';
import {
  Layout, Menu, Button, Typography, message,
  Modal, Form, Input, Drawer, Grid, List, Empty,
  Avatar, Dropdown, Tooltip, Breadcrumb, Badge, Tag, Space, Alert
} from 'antd';
import {
  DashboardOutlined, UserOutlined, BookOutlined, LogoutOutlined, TeamOutlined,
  CalendarOutlined, SolutionOutlined, FormOutlined, FileTextOutlined,
  ThunderboltOutlined, AuditOutlined, ReadOutlined, MenuOutlined,
  BulbOutlined, DownOutlined, SettingOutlined, SnippetsOutlined,
  RocketOutlined, DatabaseOutlined, AlertOutlined, SafetyCertificateOutlined,
  LeftOutlined, RightOutlined, HomeOutlined,
  SafetyOutlined,
  SearchOutlined, QuestionCircleOutlined, KeyOutlined,
  AppstoreOutlined, LineChartOutlined,
  FireOutlined,
  LockOutlined, DeploymentUnitOutlined,
  BellOutlined, BellFilled, StarOutlined, TrophyOutlined, DeleteOutlined,
  MailOutlined, ExclamationCircleOutlined, ClockCircleOutlined,
} from '@ant-design/icons';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/UserContext';
import { getRoles, getPrimaryRole } from '../utils/roles';
import { auth } from '../firebaseConfig';
import { updatePassword, signOut } from 'firebase/auth';
import {
  doc, updateDoc, collection, query, where, onSnapshot, orderBy, deleteDoc,
} from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { COLLECTIONS } from '../services/firebase/collections';
import moment from 'moment';
import NotificationPopupModal from '../components/NotificationPopupModal';
import usePageTracking from '../hooks/usePageTracking';

const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;

// ─── NOTIFICATION TYPE CONFIG - Pastel dịu nhẹ ──────────────────────────
const NOTIF_TYPE_CONFIG = {
    intervention: { bg: '#f3e8ff', color: '#a855f7', icon: <AlertOutlined />, label: 'Can thiệp' },
    risk: { bg: '#fed7aa', color: '#ea580c', icon: <ExclamationCircleOutlined />, label: 'Nguy cơ' },
    assignment: { bg: '#bbf7d0', color: '#059669', icon: <FileTextOutlined />, label: 'Bài tập' },
    grade: { bg: '#bbf7d0', color: '#059669', icon: <TrophyOutlined />, label: 'Điểm số' },
    exam: { bg: '#fef08a', color: '#ca8a04', icon: <TrophyOutlined />, label: 'Bài thi' },
    alert: { bg: '#fef08a', color: '#ca8a04', icon: <ExclamationCircleOutlined />, label: 'Nhắc nhở' },
    system: { bg: '#ddd6fe', color: '#7c3aed', icon: <BellOutlined />, label: 'Hệ thống' },
    info: { bg: '#bae6fd', color: '#0284c7', icon: <MailOutlined />, label: 'Tin tức' },
};

// ─── CASE CONFIG - Cấu hình yêu cầu phản hồi ──────────────────────────
// key = caseType (giống trong RiskInterventionModal)
const NOTIF_CASE_CONFIG = {
    warning: {
        requireResponse: true,
        responseLabel: 'Lời hứa / Phản hồi của bạn',
        responsePlaceholder: 'Hãy nhập lời hứa hoặc phản hồi của bạn về vấn đề này...',
    },
    parent_call: {
        requireResponse: true,
        responseLabel: 'Phản hồi của bạn',
        responsePlaceholder: 'Hãy nhập phản hồi về cuộc gọi này...',
    },
};
const { useBreakpoint } = Grid;

// ─── DESIGN TOKENS ───────────────────────────────────────────────────────────
const D = {
  sidebarBg:       'radial-gradient(ellipse 120% 60% at 15% 0%, rgba(99,102,241,0.16) 0%, transparent 55%), radial-gradient(ellipse 100% 50% at 100% 100%, rgba(139,92,246,0.12) 0%, transparent 60%), linear-gradient(168deg, #070d1b 0%, #0b1526 55%, #090f1f 100%)',
  sidebarBorder:   'rgba(255,255,255,0.06)',
  navText:         'rgba(148,163,184,0.88)',
  navHover:        'rgba(255,255,255,0.065)',
  navActive:       'rgba(99,102,241,0.2)',
  navActiveBorder: '#6366f1',
  navActiveText:   '#e0e7ff',
  sectionLabel:    'rgba(100,116,139,0.65)',
  headerLight:     'rgba(255,255,255,0.88)',
  headerDark:      'rgba(8,15,30,0.88)',
  headerBorderL:   'rgba(0,0,0,0.055)',
  headerBorderD:   'rgba(255,255,255,0.05)',
  indigo:          palette.primary,
  indigoDark:      palette.primaryHover,
  indigoGlow:      'rgba(99,102,241,0.3)',
  purple:          '#8b5cf6',
  emerald:         '#10b981',
  amber:           '#f59e0b',
  red:             '#ef4444',
  notifGrade:      '#10b981',
  notifAlert:      '#f59e0b',
  notifSystem:     '#6366f1',
  notifInfo:       '#3b82f6',
};

const ROUTE_META = {
  '/':                     { label: 'Dashboard',              icon: <DashboardOutlined /> },
  '/student-dashboard':    { label: 'Dashboard',              icon: <SolutionOutlined /> },
  '/syllabus':             { label: 'Lộ trình Học tập',      icon: <ReadOutlined /> },
  '/schedule':             { label: 'Lịch học tổng hợp',     icon: <CalendarOutlined /> },
  '/gradebook':            { label: 'Sổ điểm',               icon: <AuditOutlined /> },
  '/pcap':                 { label: "Luyện thi PCAP",       icon: <SafetyCertificateOutlined /> },
  '/student-profile':      { label: 'Tổng kết Học sinh',      icon: <SolutionOutlined /> },
  '/learning-materials':   { label: 'Tài liệu học tập',      icon: <SnippetsOutlined /> },
  '/lessons':              { label: 'Quản lý Buổi Học',      icon: <CalendarOutlined /> },
  '/assignments':          { label: 'Quản lý Bài tập',       icon: <FileTextOutlined /> },
  '/exams':                { label: 'Quản lý Bài thi',       icon: <ThunderboltOutlined /> },
  '/projects':             { label: 'Đồ Án Cuối Học Phần',  icon: <RocketOutlined /> },
  '/reports':              { label: 'Báo Cáo Định Kỳ',      icon: <FormOutlined /> },
  '/classes':              { label: 'Quản lý Lớp học',       icon: <TeamOutlined /> },
  '/subjects':             { label: 'Quản lý Môn học',       icon: <BookOutlined /> },
  '/users':                { label: 'Quản lý Người dùng',   icon: <UserOutlined /> },
  '/database-admin':       { label: 'Quản trị Database',     icon: <DatabaseOutlined /> },
  '/risk-analysis':        { label: 'Phân tích Học sinh Nguy cơ', icon: <AlertOutlined /> },
  '/interventions':        { label: 'Student Care',           icon: <AlertOutlined /> },
  '/student-care':         { label: 'Student Care',           icon: <AlertOutlined /> },
  '/visit-analytics':      { label: 'Lượt truy cập Website',  icon: <LineChartOutlined /> },
  '/question-bank':        { label: 'Ngân hàng Câu hỏi',      icon: <BookOutlined /> },
  '/pcap-theory':          { label: "Tài liệu PCAP", icon: <ReadOutlined /> },
  '/pcap-content-admin':   { label: 'Quản trị Nội dung PCAP', icon: <DatabaseOutlined /> },
  '/profile':              { label: 'Hồ sơ cá nhân',         icon: <SettingOutlined /> },
  '/my-certificates':       { label: 'Chứng chỉ của tôi',     icon: <SafetyCertificateOutlined /> },
  '/certificate-management':{ label: 'Quản lý Chứng chỉ',    icon: <SafetyCertificateOutlined /> },
};

const MENU_GROUPS = [
  {
    section: 'TỔNG QUAN',
    sectionIcon: <HomeOutlined />,
    roles: ['admin','teacher','coordinator','student','parent'],
    items: [
      { key: '/',                  icon: <DashboardOutlined />,   label: 'Dashboard',           roles: ['admin','teacher','coordinator'] },
      { key: '/student-dashboard', icon: <SolutionOutlined />,    label: 'Dashboard',           roles: ['student','parent'] },
    ],
  },
  {
    section: 'HỌC TẬP',
    sectionIcon: <ReadOutlined />,
    roles: ['admin','teacher','coordinator','student','parent'],
    items: [
      { key: '/syllabus',           icon: <ReadOutlined />,      label: 'Lộ trình Học tập',    roles: ['admin','teacher','student','parent','coordinator'] },
      { key: '/schedule',           icon: <CalendarOutlined />,  label: 'Lịch học tổng hợp',   roles: ['admin','teacher','student','parent','coordinator'] },
      { key: '/gradebook',          icon: <AuditOutlined />,     label: 'Sổ điểm',             roles: ['admin','teacher','student','parent','coordinator'] },
      { key: '/learning-materials', icon: <SnippetsOutlined />,  label: 'Tài liệu học tập',   roles: ['admin','teacher','student'] },
      { key: '/projects',           icon: <RocketOutlined />,    label: 'Đồ Án Cuối Học Phần',roles: ['admin','teacher','student','parent','coordinator'] },
      { key: '/my-certificates',    icon: <SafetyCertificateOutlined />, label: 'Chứng chỉ của tôi', roles: ['student','parent'] },
      { key: '/student-care',       icon: <AlertOutlined />,     label: 'Student Care',        roles: ['student','parent'] },
    ],
  },
  {
    section: 'LUYỆN THI PCAP',
    sectionIcon: <DeploymentUnitOutlined />,
    roles: ['admin','teacher','coordinator','student','parent'],
    items: [
      { key: '/pcap',               icon: <SafetyCertificateOutlined />, label: "Thông tin PCAP",   roles: ['admin','teacher','student','coordinator'] },
      { key: '/pcap-theory',        icon: <ReadOutlined />,      label: "Tài liệu PCAP", roles: ['admin','teacher','student','coordinator'] },
      { key: '/pcap-practice',       icon: <SafetyOutlined />,             label: "Luyện thi PCAP",           roles: ['admin','teacher','student','coordinator'] },
    ],
  },
  {
    section: 'QUẢN LÝ',
    sectionIcon: <TeamOutlined />,
    roles: ['admin','teacher','coordinator'],
    items: [
      { key: '/lessons',     icon: <CalendarOutlined />,   label: 'Buổi Học', roles: ['admin','teacher','coordinator'] },
      { key: '/assignments', icon: <FileTextOutlined />,   label: 'Bài tập',  roles: ['admin','teacher','coordinator'] },
      { key: '/exams',       icon: <ThunderboltOutlined />,label: 'Bài thi',  roles: ['admin','teacher','coordinator'] },
      { key: '/reports',     icon: <FormOutlined />,       label: 'Báo Cáo',  roles: ['admin','teacher','coordinator'] },
      { key: '/student-profile', icon: <SolutionOutlined />, label: 'Tổng kết Học sinh', roles: ['admin','teacher','coordinator'] },
      { key: '/certificate-management', icon: <SafetyCertificateOutlined />, label: 'Quản lý Chứng chỉ', roles: ['admin','teacher','coordinator'] },
    ],
  },
  {
    section: 'HỆ THỐNG',
    sectionIcon: <SettingOutlined />,
    roles: ['admin','coordinator'],
    items: [
      { key: '/classes',  icon: <TeamOutlined />,   label: 'Lớp học',      roles: ['admin','coordinator'] },
      { key: '/subjects', icon: <BookOutlined />,   label: 'Môn học',      roles: ['admin'] },
      { key: '/users',    icon: <UserOutlined />,   label: 'Người dùng',  roles: ['admin','coordinator'] },
      { key: '/database-admin', icon: <DatabaseOutlined />, label: 'Quản trị Database', roles: ['admin'] },
      { key: '/visit-analytics', icon: <LineChartOutlined />, label: 'Lượt truy cập Website', roles: ['admin','coordinator'] },
      { key: '/risk-analysis', icon: <AlertOutlined />, label: 'Học sinh Nguy cơ', roles: ['admin','coordinator'] },
      { key: '/interventions', icon: <AlertOutlined />, label: 'Student Care', roles: ['admin','teacher','coordinator'] },
      { key: '/question-bank', icon: <BookOutlined />, label: 'Ngân hàng Câu hỏi', roles: ['admin','teacher','coordinator'] },
      { key: '/pcap-content-admin', icon: <DatabaseOutlined />, label: 'Quản trị Nội dung PCAP', roles: ['admin'] },
    ],
  },
];

const ROLE_LABELS = {
  admin:       { label: 'Quản trị viên', color: '#fbbf24', bg: 'rgba(251,191,36,.12)',  icon: '' },
  teacher:     { label: 'Giáo viên',     color: '#34d399', bg: 'rgba(52,211,153,.12)',  icon: '' },
  coordinator: { label: 'Điều phối',     color: '#60a5fa', bg: 'rgba(96,165,250,.12)',  icon: '' },
  student:     { label: 'Học sinh',      color: '#a78bfa', bg: 'rgba(167,139,250,.12)', icon: '' },
  parent:      { label: 'Phụ huynh',    color: '#f87171', bg: 'rgba(248,113,113,.12)', icon: '' },
};

const BOTTOM_NAV_ITEMS_STUDENT = [
  { key: '/student-dashboard', icon: <HomeOutlined />,        label: 'Home',     roles: ['student','parent'] },
  { key: '/gradebook',         icon: <AuditOutlined />,       label: 'Điểm',     roles: ['student','parent'] },
  { key: '/syllabus',          icon: <ReadOutlined />,        label: 'Lộ trình', roles: ['student','parent'] },
  { key: '/projects',          icon: <RocketOutlined />,      label: 'Đồ Án',    roles: ['student','parent'] },
];
const BOTTOM_NAV_ITEMS_TEACHER = [
  { key: '/',            icon: <HomeOutlined />,        label: 'Home',     roles: ['admin','teacher','coordinator'] },
  { key: '/lessons',     icon: <CalendarOutlined />,    label: 'Buổi học', roles: ['admin','teacher','coordinator'] },
  { key: '/exams',       icon: <ThunderboltOutlined />, label: 'Bài thi',  roles: ['admin','teacher','coordinator'] },
  { key: '/gradebook',   icon: <AuditOutlined />,       label: 'Sổ điểm', roles: ['admin','teacher','coordinator'] },
  { key: '/classes',     icon: <TeamOutlined />,        label: 'Lớp',      roles: ['admin','coordinator'] },
  { key: '/certificate-management', icon: <SafetyCertificateOutlined />, label: 'Chứng chỉ', roles: ['admin','teacher','coordinator'] },
];

// ─── CSS ─────────────────────────────────────────────────────────────────────
const buildCSS = (isDarkMode) => `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,600&family=JetBrains+Mono:wght@500;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; }
  body { font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif !important; -webkit-font-smoothing: antialiased; }

  /* ══════════════════════════════════════════════════
     KEYFRAMES
  ══════════════════════════════════════════════════ */
  @keyframes slideInLeft  { from{opacity:0;transform:translateX(-14px)} to{opacity:1;transform:translateX(0)} }
  @keyframes slideInRight { from{opacity:0;transform:translateX(14px)}  to{opacity:1;transform:translateX(0)} }
  @keyframes fadeUp       { from{opacity:0;transform:translateY(10px)}  to{opacity:1;transform:translateY(0)} }
  @keyframes scalePop     { 0%{transform:scale(.88);opacity:0} 70%{transform:scale(1.04)} 100%{transform:scale(1);opacity:1} }
  @keyframes shimmer      { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
  @keyframes breathe      { 0%,100%{opacity:.6;transform:scale(1)} 50%{opacity:1;transform:scale(1.18)} }
  @keyframes ringPulse    { 0%{box-shadow:0 0 0 0 rgba(99,102,241,.55)} 70%{box-shadow:0 0 0 10px rgba(99,102,241,0)} 100%{box-shadow:0 0 0 0 rgba(99,102,241,0)} }
  @keyframes dotBlink     { 0%,100%{box-shadow:0 0 0 0 rgba(16,185,129,.7)} 60%{box-shadow:0 0 0 7px rgba(16,185,129,0)} }
  @keyframes spotFade     { from{opacity:0} to{opacity:1} }
  @keyframes spotUp       { from{opacity:0;transform:translateY(-18px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }
  @keyframes notifSlide   { from{opacity:0;transform:translateX(18px)} to{opacity:1;transform:translateX(0)} }
  @keyframes badgePop     { 0%{transform:scale(0)} 70%{transform:scale(1.3)} 100%{transform:scale(1)} }

  /* Dark mode text overrides */
  ${isDarkMode ? `
    .et-content-inner, .et-content-layout { color: rgba(255,255,255,0.88) !important; }
    .ant-typography, .ant-typography h1, .ant-typography h2, .ant-typography h3,
    .ant-typography h4, .ant-typography h5, .ant-typography p, .ant-typography span { color: rgba(255,255,255,0.88) !important; }
    .ant-table { color: rgba(255,255,255,0.88) !important; }
    .ant-table-thead > tr > th { color: rgba(255,255,255,0.7) !important; background: rgba(255,255,255,0.04) !important; border-bottom: 1px solid rgba(255,255,255,0.08) !important; }
    .ant-table-tbody > tr > td { color: rgba(255,255,255,0.85) !important; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
    .ant-table-tbody > tr:hover > td { background: rgba(255,255,255,0.04) !important; }
    .ant-select-selector, .ant-picker, .ant-input { color: rgba(255,255,255,0.88) !important; }
    .ant-modal-title { color: rgba(255,255,255,0.95) !important; }
    .ant-modal-content { background: rgba(15, 12, 41, 0.95) !important; backdrop-filter: blur(30px) !important; border: 1px solid rgba(255,255,255,0.1) !important; }
  ` : ''}
  @keyframes gradientShift{ 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }
  @keyframes pulseRed     { 0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,.5)} 60%{box-shadow:0 0 0 8px rgba(239,68,68,0)} }

  /* ══════════════════════════════════════════════════
     SCROLLBAR - Enhanced for sidebar
  ══════════════════════════════════════════════════ */
  .sidebar-scroll {
    scrollbar-width: thin;
    scrollbar-color: rgba(99,102,241,.5) rgba(255,255,255,.05);
    scroll-behavior: smooth;
  }
  .sidebar-scroll::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .sidebar-scroll::-webkit-scrollbar-track {
    background: rgba(0,0,0,.1);
    border-radius: 4px;
  }
  .sidebar-scroll::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, rgba(99,102,241,.8), rgba(139,92,246,.6));
    border-radius: 4px;
  }
  .sidebar-scroll::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, rgba(99,102,241,1), rgba(139,92,246,.9));
  }
  .sidebar-scroll::-webkit-scrollbar-corner {
    background: transparent;
  }

  /* Ensure sidebar content scrolls properly */
  .et-sidebar .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .et-sidebar .ant-layout-sider-children::-webkit-scrollbar {
    width: 5px;
  }
  .et-sidebar .ant-layout-sider-children::-webkit-scrollbar-thumb {
    background: rgba(99,102,241,.5);
    border-radius: 3px;
  }

  /* ══════════════════════════════════════════════════
     SIDEBAR
  ══════════════════════════════════════════════════ */
  .et-sidebar {
    position: relative;
    /* Animated gradient orbs background */
    background:
      radial-gradient(ellipse 160px 120px at 30% 20%, rgba(99,102,241,.07) 0%, transparent 100%),
      radial-gradient(ellipse 120px 180px at 80% 70%, rgba(139,92,246,.05) 0%, transparent 100%),
      linear-gradient(168deg, #070d1c 0%, #0a1220 55%, #090e1c 100%) !important;
  }
  /* Right edge glow line */
  .et-sidebar::after {
    content:''; position:absolute; top:0; right:0; width:1px; height:100%;
    background: linear-gradient(180deg, transparent 0%, rgba(99,102,241,.5) 35%, rgba(139,92,246,.3) 65%, transparent 100%);
    pointer-events:none;
  }

  /* ── MENU ── */
  .et-menu.ant-menu { background:transparent !important; border-inline-end:none !important; }
  .et-menu .ant-menu-item {
    border-radius:12px !important; margin:2px 8px !important;
    width:calc(100% - 16px) !important; padding:0 13px !important;
    height:40px !important; line-height:40px !important;
    font-weight:600 !important; font-size:13px !important;
    color:rgba(148,163,184,.85) !important;
    transition:all .22s cubic-bezier(.34,1.56,.64,1) !important;
    position:relative; overflow:visible !important;
  }
  .et-menu .ant-menu-item:hover:not(.ant-menu-item-selected) {
    background:rgba(255,255,255,.055) !important;
    color:rgba(255,255,255,.92) !important;
    transform:translateX(4px) !important;
  }
  .et-menu .ant-menu-item.ant-menu-item-selected {
    background:linear-gradient(105deg,rgba(99,102,241,.26) 0%,rgba(99,102,241,.08) 100%) !important;
    color:#e0e7ff !important; font-weight:800 !important;
    box-shadow:inset 0 0 0 1px rgba(99,102,241,.22), 0 4px 12px rgba(99,102,241,.12) !important;
    transform:translateX(2px) !important;
  }
  /* Animated left bar */
  .et-menu .ant-menu-item.ant-menu-item-selected::before {
    content:''; position:absolute; left:-8px; top:50%; transform:translateY(-50%);
    width:3px; height:0; border-radius:0 4px 4px 0;
    background:linear-gradient(180deg,#818cf8,${D.purple});
    animation:navBarGrow .3s cubic-bezier(.34,1.56,.64,1) forwards;
    box-shadow:0 0 8px rgba(99,102,241,.6);
  }
  @keyframes navBarGrow { from{height:0} to{height:24px} }
  @keyframes sidebarBreathe { 0%,100%{opacity:.7; transform:scale(1)} 50%{opacity:1; transform:scale(1.15)} }
  .et-sidebar-breathe { animation: sidebarBreathe 7s ease-in-out infinite; }
  .et-menu .ant-menu-item.ant-menu-item-selected::after { display:none !important; }
  .et-menu .ant-menu-item-icon {
    font-size:14px !important; transition:all .22s cubic-bezier(.34,1.56,.64,1) !important;
    width:26px !important; height:26px !important; border-radius:8px !important;
    display:inline-flex !important; align-items:center !important; justify-content:center !important;
    background:rgba(255,255,255,.04) !important; margin-right:2px !important;
  }
  .et-menu .ant-menu-item.ant-menu-item-selected .ant-menu-item-icon {
    background:linear-gradient(135deg,rgba(99,102,241,.35),rgba(139,92,246,.25)) !important;
    box-shadow:0 2px 8px rgba(99,102,241,.25) !important;
    transform:scale(1.05);
  }
  .et-menu .ant-menu-item:hover .ant-menu-item-icon { background:rgba(255,255,255,.08) !important; transform:scale(1.05) rotate(-4deg); }
  .et-menu .ant-menu-title-content a { color:inherit !important; text-decoration:none !important; }

  /* ── SECTION LABELS (giờ bấm được để thu gọn/mở rộng cả nhóm) ── */
  .nav-section-label {
    font-size:9.5px; font-weight:900; letter-spacing:.14em;
    color:rgba(148,163,184,.55); padding:16px 16px 6px 12px;
    text-transform:uppercase; user-select:none; cursor:pointer;
    display:flex; align-items:center; gap:7px;
    transition:color .18s ease;
  }
  .nav-section-label:hover { color:rgba(226,232,240,.8) !important; }
  .nav-section-label::after { content:''; flex:1; height:1px; background:rgba(255,255,255,.045); transition:background .18s ease; }
  .nav-section-label:hover::after { background:rgba(129,140,248,.18); }
  .nav-section-label.first { padding-top:8px; }
  .nav-section-chevron {
    display:flex; align-items:center; justify-content:center;
    width:14px; height:14px; font-size:8px; flex-shrink:0;
    transition:transform .25s cubic-bezier(.34,1.56,.64,1);
    transform:rotate(90deg);
    color:rgba(148,163,184,.45);
  }
  .nav-section-icon {
    display:flex; align-items:center; justify-content:center;
    font-size:11px; color:rgba(148,163,184,.5); flex-shrink:0;
    transition:color .18s ease;
  }
  .nav-section-label:hover .nav-section-icon { color:rgba(129,140,248,.85); }
  .nav-section-label:hover .nav-section-chevron { color:rgba(129,140,248,.85); }
  .nav-section-label.is-collapsed .nav-section-chevron { transform:rotate(0deg); }
  .nav-section-dot {
    width:6px; height:6px; border-radius:50%; flex-shrink:0;
    background:linear-gradient(135deg,#818cf8,${D.purple});
    box-shadow:0 0 6px rgba(129,140,248,.7);
    animation:navDotPulse 2s ease-in-out infinite;
  }
  @keyframes navDotPulse { 0%,100%{opacity:1} 50%{opacity:.4} }
  .nav-section-divider { height:1px; background:rgba(255,255,255,.04); margin:6px 12px; }

  .nav-group-body {
    display:grid; grid-template-rows:1fr; opacity:1;
    transition:grid-template-rows .28s cubic-bezier(.4,0,.2,1), opacity .22s ease;
  }
  .nav-group-body > .ant-menu { overflow:hidden; min-height:0; }
  .nav-group-body.collapsed { grid-template-rows:0fr; opacity:0; }
  .nav-group-body.collapsed > .ant-menu { overflow:hidden; }



  /* ── SIDEBAR SEARCH BTN ── */
  .sidebar-search-btn {
    margin:4px 10px 8px; width:calc(100% - 20px);
    background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.07);
    border-radius:11px; padding:8px 13px; display:flex; align-items:center; gap:9px;
    cursor:pointer; transition:all .2s; color:#475569;
  }
  .sidebar-search-btn:hover {
    background:rgba(99,102,241,.12); border-color:rgba(99,102,241,.3);
    color:#818cf8; transform:translateY(-1px);
    box-shadow:0 4px 14px rgba(99,102,241,.12);
  }

  /* ── SIDEBAR FOOTER ── */
  .sidebar-footer { padding:8px; border-top:1px solid rgba(255,255,255,.05); background:rgba(0,0,0,.18); flex-shrink:0; }
  .sidebar-footer-inner {
    display:flex; align-items:center; gap:10px; padding:8px 10px; border-radius:12px;
    cursor:pointer; transition:all .2s;
  }
  .sidebar-footer-inner:hover { background:rgba(255,255,255,.07); }

  /* ══════════════════════════════════════════════════
     HEADER
  ══════════════════════════════════════════════════ */
  .et-header {
    background:${isDarkMode
      ? 'rgba(7,13,28,.92)'
      : 'rgba(255,255,255,.9)'} !important;
    backdrop-filter:blur(32px) saturate(180%) !important;
    -webkit-backdrop-filter:blur(32px) saturate(180%) !important;
    border-bottom:1px solid ${isDarkMode ? 'rgba(255,255,255,.055)' : 'rgba(0,0,0,.055)'} !important;
    box-shadow:${isDarkMode
      ? '0 1px 0 rgba(255,255,255,.04),0 8px 32px rgba(0,0,0,.2)'
      : '0 1px 0 rgba(0,0,0,.05),0 8px 32px rgba(0,0,0,.06)'} !important;
    position:sticky !important; top:0 !important; z-index:50 !important;
    padding:0 20px !important; height:60px !important; line-height:60px !important;
    display:flex !important; align-items:center !important; justify-content:space-between !important;
    animation:slideInRight .4s cubic-bezier(.16,1,.3,1);
  }

  /* ── ICON BUTTONS ── */
  .et-icon-btn {
    width:36px !important; height:36px !important; border-radius:10px !important;
    border:1px solid ${isDarkMode ? 'rgba(255,255,255,.07)' : 'rgba(0,0,0,.06)'} !important;
    background:${isDarkMode ? 'rgba(255,255,255,.04)' : 'rgba(0,0,0,.025)'} !important;
    color:${isDarkMode ? '#94a3b8' : '#64748b'} !important;
    display:flex !important; align-items:center !important; justify-content:center !important;
    transition:all .22s cubic-bezier(.34,1.56,.64,1) !important;
    font-size:15px !important; cursor:pointer;
  }
  .et-icon-btn:hover {
    background:${isDarkMode ? 'rgba(255,255,255,.1)' : 'rgba(0,0,0,.07)'} !important;
    color:${isDarkMode ? '#e2e8f0' : '#0f172a'} !important;
    border-color:${isDarkMode ? 'rgba(255,255,255,.15)' : 'rgba(0,0,0,.13)'} !important;
    transform:translateY(-2px) scale(1.06) !important;
    box-shadow:0 4px 12px rgba(0,0,0,.12) !important;
  }
  .et-icon-btn.active {
    background:rgba(99,102,241,.15) !important;
    border-color:rgba(99,102,241,.4) !important;
    color:${D.indigo} !important;
    box-shadow:0 0 0 3px rgba(99,102,241,.1) !important;
    animation:ringPulse 1.8s ease infinite;
  }

  /* ── PROFILE PILL ── */
  .et-profile-pill {
    background:${isDarkMode ? 'rgba(255,255,255,.045)' : 'rgba(0,0,0,.03)'};
    border:1px solid ${isDarkMode ? 'rgba(255,255,255,.09)' : 'rgba(0,0,0,.07)'};
    border-radius:40px; padding:4px 14px 4px 4px; height:42px;
    display:flex; align-items:center; gap:9px; cursor:pointer;
    transition:all .22s cubic-bezier(.34,1.56,.64,1); user-select:none;
  }
  .et-profile-pill:hover {
    background:${isDarkMode ? 'linear-gradient(105deg,rgba(99,102,241,.14),rgba(139,92,246,.08))' : 'rgba(99,102,241,.06)'};
    border-color:rgba(99,102,241,.35);
    transform:translateY(-1px);
    box-shadow:0 6px 18px rgba(99,102,241,.16), inset 0 0 0 1px rgba(99,102,241,.08);
  }
  .et-profile-pill .ant-avatar {
    box-shadow:0 2px 8px rgba(99,102,241,.3);
  }
  .et-profile-pill:hover .ant-avatar {
    box-shadow:0 4px 14px rgba(99,102,241,.45);
  }
  .online-dot {
    width:8px; height:8px; border-radius:50%;
    background:radial-gradient(circle at 35% 30%, #34e8a8, #10b981);
    box-shadow:0 0 5px rgba(16,185,129,.7);
    flex-shrink:0;
    animation:dotBlink 2.4s ease infinite;
  }

  /* ══════════════════════════════════════════════════
     NOTIFICATION DRAWER
  ══════════════════════════════════════════════════ */
  .et-notif-drawer .ant-drawer-content-wrapper { animation:slideInRight .3s cubic-bezier(.16,1,.3,1) !important; }
  .et-notif-drawer .ant-drawer-header { border-bottom:1px solid ${isDarkMode ? 'rgba(255,255,255,.07)' : '#f1f5f9'} !important; padding:0 !important; background:${isDarkMode ? '#07101e' : '#fff'} !important; }
  .et-notif-drawer .ant-drawer-body { padding:0 !important; background:${isDarkMode ? '#070d1c' : '#f8fafc'} !important; overflow-y:auto; }
  .et-notif-drawer .ant-drawer-footer { border-top:1px solid ${isDarkMode ? 'rgba(255,255,255,.07)' : '#f1f5f9'} !important; padding:10px 16px !important; background:${isDarkMode ? '#07101e' : '#fff'} !important; }
  .notif-item {
    padding:13px 18px; display:flex; gap:11px; align-items:flex-start;
    border-bottom:1px solid ${isDarkMode ? 'rgba(255,255,255,.04)' : '#f1f5f9'};
    cursor:pointer; transition:all .18s;
    animation:notifSlide .3s both;
  }
  .notif-item:hover { background:${isDarkMode ? 'rgba(255,255,255,.04)' : '#f1f5f9'}; padding-left:22px; }
  .notif-item.unread { background:${isDarkMode ? 'rgba(99,102,241,.09)' : '#eef2ff'}; }
  .notif-item.unread:hover { background:${isDarkMode ? 'rgba(99,102,241,.14)' : '#e0e7ff'}; padding-left:22px; }

  /* ══════════════════════════════════════════════════
     SEARCH SPOTLIGHT
  ══════════════════════════════════════════════════ */
  .search-spotlight {
    position:fixed; inset:0; z-index:999;
    background:${isDarkMode ? 'rgba(4,8,18,.75)' : 'rgba(15,23,42,.45)'};
    backdrop-filter:blur(8px) saturate(140%);
    display:flex; align-items:flex-start; justify-content:center; padding-top:100px;
    animation:spotFade .2s ease;
  }
  .search-box {
    background:${isDarkMode ? 'linear-gradient(145deg,#0d1630,#0a1220)' : '#fff'};
    border-radius:22px; width:92%; max-width:580px;
    border:1px solid ${isDarkMode ? 'rgba(99,102,241,.25)' : 'rgba(99,102,241,.15)'};
    box-shadow:${isDarkMode
      ? '0 32px 80px rgba(0,0,0,.6),0 0 0 1px rgba(99,102,241,.15),inset 0 1px 0 rgba(255,255,255,.04)'
      : '0 24px 60px rgba(0,0,0,.18),0 0 0 1px rgba(99,102,241,.12)'};
    overflow:hidden; animation:spotUp .28s cubic-bezier(.16,1,.3,1);
  }
  .search-input-wrap {
    display:flex; align-items:center; padding:16px 20px; gap:12px;
    border-bottom:1px solid ${isDarkMode ? 'rgba(255,255,255,.07)' : '#f1f5f9'};
    background:${isDarkMode ? 'rgba(99,102,241,.06)' : 'rgba(99,102,241,.03)'};
  }
  .search-result-item {
    display:flex; align-items:center; gap:12px; padding:11px 20px;
    cursor:pointer; transition:all .15s;
  }
  .search-result-item:hover { background:${isDarkMode ? 'rgba(255,255,255,.04)' : '#f8fafc'}; }
  .search-result-item.selected {
    background:${isDarkMode ? 'rgba(99,102,241,.18)' : '#eef2ff'};
    border-left:3px solid ${D.indigo};
    padding-left:17px;
  }
  .search-footer {
    padding:9px 20px; border-top:1px solid ${isDarkMode ? 'rgba(255,255,255,.05)' : '#f1f5f9'};
    display:flex; gap:14px; align-items:center;
    background:${isDarkMode ? 'rgba(0,0,0,.18)' : 'rgba(0,0,0,.018)'};
  }

  /* ══════════════════════════════════════════════════
     MOBILE BOTTOM NAV
  ══════════════════════════════════════════════════ */
  .et-bottom-nav {
    position:fixed; bottom:0; left:0; right:0; height:64px;
    background:${isDarkMode ? 'rgba(7,13,28,.96)' : 'rgba(255,255,255,.96)'};
    backdrop-filter:blur(28px) saturate(160%); -webkit-backdrop-filter:blur(28px);
    border-top:1px solid ${isDarkMode ? 'rgba(255,255,255,.07)' : 'rgba(0,0,0,.07)'};
    display:flex; align-items:stretch; z-index:200;
    box-shadow:0 -8px 32px rgba(0,0,0,.12); padding-bottom:env(safe-area-inset-bottom);
  }
  .et-bottom-nav-item {
    flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center;
    gap:3px; cursor:pointer; color:${isDarkMode ? '#3d4f6b' : '#94a3b8'};
    font-size:9.5px; font-weight:800; transition:all .22s cubic-bezier(.34,1.56,.64,1);
    text-decoration:none; padding-top:6px; position:relative; border:none; background:none;
    letter-spacing:.02em; text-transform:uppercase;
  }
  .et-bottom-nav-item.active { color:${D.indigo}; }
  .et-bottom-nav-item.active .nav-icon { transform:translateY(-2px) scale(1.12); }
  .et-bottom-nav-item.active::before {
    content:''; position:absolute; top:0; left:50%; transform:translateX(-50%);
    width:36px; height:3px;
    background:linear-gradient(90deg,${D.indigo},${D.purple});
    border-radius:0 0 4px 4px; box-shadow:0 0 8px rgba(99,102,241,.4);
  }
  .et-bottom-nav-item .nav-icon { font-size:20px; line-height:1; transition:transform .22s cubic-bezier(.34,1.56,.64,1); }

  /* ══════════════════════════════════════════════════
     MOBILE DRAWER
  ══════════════════════════════════════════════════ */
  .et-mobile-drawer .ant-drawer-content-wrapper { animation:slideInLeft .3s cubic-bezier(.16,1,.3,1) !important; }
  .et-mobile-drawer .ant-drawer-header { background:#070d1c !important; border-bottom:1px solid rgba(255,255,255,.06) !important; padding:14px !important; }
  .et-mobile-drawer .ant-drawer-body { padding:0 !important; background:linear-gradient(168deg,#070d1c 0%,#0a1220 100%) !important; display:flex; flex-direction:column; }
  .et-mobile-drawer .ant-drawer-close { color:#94a3b8 !important; }

  /* ══════════════════════════════════════════════════
     USER DROPDOWN
  ══════════════════════════════════════════════════ */
  .et-user-menu .ant-dropdown-menu {
    border-radius:18px !important; padding:6px !important; min-width:230px;
    box-shadow:${isDarkMode
      ? '0 24px 64px rgba(0,0,0,.5),0 0 0 1px rgba(255,255,255,.07),inset 0 1px 0 rgba(255,255,255,.04)'
      : '0 20px 60px rgba(0,0,0,.15),0 0 0 1px rgba(0,0,0,.05)'} !important;
    background:${isDarkMode ? '#0b1525' : '#fff'} !important;
    border:none !important; animation:scalePop .22s !important;
  }
  .et-user-menu .ant-dropdown-menu-item { border-radius:10px !important; padding:9px 12px !important; font-weight:600 !important; color:${isDarkMode ? '#cbd5e1' : '#334155'} !important; transition:all .15s !important; }
  .et-user-menu .ant-dropdown-menu-item:hover { background:${isDarkMode ? 'rgba(255,255,255,.07)' : '#f8fafc'} !important; padding-left:16px !important; }
  .et-user-menu .ant-dropdown-menu-item-divider { background:${isDarkMode ? 'rgba(255,255,255,.06)' : '#f1f5f9'} !important; }

  /* ══════════════════════════════════════════════════
     MODAL
  ══════════════════════════════════════════════════ */
  .et-pw-modal .ant-modal-content { border-radius:24px !important; overflow:hidden; background:${isDarkMode ? '#0b1525' : '#fff'} !important; box-shadow:0 32px 80px rgba(0,0,0,.22),0 0 0 1px rgba(99,102,241,.1) !important; animation:scalePop .3s !important; }
  .et-pw-modal .ant-modal-header { background:${isDarkMode ? '#0b1525' : '#fff'} !important; border-bottom:1px solid ${isDarkMode ? 'rgba(255,255,255,.07)' : '#f1f5f9'} !important; padding:22px 26px !important; margin:0 !important; }
  .et-pw-modal .ant-modal-body { padding:22px 26px !important; }
  .et-pw-modal .ant-modal-footer { padding:14px 26px !important; border-top:1px solid ${isDarkMode ? 'rgba(255,255,255,.07)' : '#f1f5f9'} !important; margin:0 !important; }

  /* ══════════════════════════════════════════════════
     MISC
  ══════════════════════════════════════════════════ */
  .et-breadcrumb .ant-breadcrumb-separator { color:${isDarkMode ? '#2d3f5a' : '#d1d5db'} !important; }
  .et-breadcrumb .ant-breadcrumb-link { color:${isDarkMode ? '#64748b' : '#9ca3af'} !important; font-weight:600; font-size:11.5px; }
  .et-breadcrumb .ant-breadcrumb-link:last-child { color:${isDarkMode ? '#e2e8f0' : '#111827'} !important; }

  .et-collapse-btn {
    position:fixed; top:18px; width:26px; height:26px; border-radius:50%;
    background:${isDarkMode ? '#1a2744' : '#fff'};
    border:1px solid ${isDarkMode ? 'rgba(99,102,241,.35)' : 'rgba(0,0,0,.1)'};
    display:flex; align-items:center; justify-content:center; cursor:pointer; z-index:200;
    box-shadow:0 2px 10px rgba(0,0,0,.18); transition:left .28s cubic-bezier(.22,1,.36,1), all .22s cubic-bezier(.34,1.56,.64,1);
    color:${isDarkMode ? '#6366f1' : '#94a3b8'}; font-size:10px;
  }
  .et-collapse-btn:hover { background:${D.indigo}; color:#fff; border-color:${D.indigo}; transform:scale(1.18); box-shadow:0 0 0 4px rgba(99,102,241,.2); }

  .et-content-layout { transition:margin-left .28s cubic-bezier(.22,1,.36,1) !important; }
  .notif-dot-pulse { animation:pulseRed 2.2s ease infinite; }
  .kbd { display:inline-flex; align-items:center; justify-content:center; padding:2px 6px; border-radius:5px; font-size:9.5px; font-weight:700; font-family:'JetBrains Mono',monospace; background:${isDarkMode ? 'rgba(255,255,255,.08)' : 'rgba(0,0,0,.06)'}; color:${isDarkMode ? '#64748b' : '#6b7280'}; border:1px solid ${isDarkMode ? 'rgba(255,255,255,.1)' : 'rgba(0,0,0,.09)'}; }

  /* Page title icon animate on route change */
  .page-title-icon { animation:scalePop .35s cubic-bezier(.16,1,.3,1); }

  @media(max-width:767px) { .et-content-inner { padding-bottom:72px !important; } }
  @media(max-width:575px) { .hide-xs { display:none !important; } }
`;

// ─── NEW F1: SEARCH SPOTLIGHT ─────────────────────────────────────────────────
function SearchSpotlight({ open, onClose, userRoles, navigate, isDarkMode }) {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(0);
  const inputRef = useRef(null);

  // 1 người có thể có nhiều vai trò — mục menu hiện ra nếu KHỚP ÍT NHẤT 1 vai trò.
  // 'coordinator' được coi tương đương 'admin' (trừ mục /subjects chỉ admin thật mới thấy).
  const allRoutes = useMemo(() => MENU_GROUPS.flatMap(g => g.items).filter(item =>
    item.roles.some(r => userRoles.includes(r)) ||
    (userRoles.includes('coordinator') && item.roles.includes('admin') && item.key !== '/subjects')
  ), [userRoles]);

  const results = useMemo(() => {
    if (!query.trim()) return allRoutes.slice(0, 6);
    const q = query.toLowerCase();
    return allRoutes.filter(r => r.label.toLowerCase().includes(q) || r.key.toLowerCase().includes(q)).slice(0, 8);
  }, [query, allRoutes]);

  useEffect(() => { if (open) { setTimeout(() => inputRef.current?.focus(), 80); setQuery(''); setSelected(0); } }, [open]);
  useEffect(() => { setSelected(0); }, [results.length]);

  const handleKey = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setSelected(s => Math.min(s + 1, results.length - 1)); }
    if (e.key === 'ArrowUp')   { e.preventDefault(); setSelected(s => Math.max(s - 1, 0)); }
    if (e.key === 'Enter' && results[selected]) { navigate(results[selected].key); onClose(); }
    if (e.key === 'Escape') onClose();
  };

  if (!open) return null;
  const textColor = isDarkMode ? '#e2e8f0' : '#1e293b';
  const subColor  = isDarkMode ? '#64748b'  : '#94a3b8';
  return (
    <div className="search-spotlight" onClick={onClose}>
      <div className="search-box" onClick={e => e.stopPropagation()} onKeyDown={handleKey}>
        {/* Input */}
        <div className="search-input-wrap">
          <div style={{ width: 36, height: 36, borderRadius: 10, background: `rgba(99,102,241,.15)`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <SearchOutlined style={{ fontSize: 17, color: '#818cf8' }} />
          </div>
          <input ref={inputRef} value={query} onChange={e => setQuery(e.target.value)}
            placeholder="Tìm trang, chức năng..."
            style={{ flex: 1, border: 'none', outline: 'none', fontSize: 16, fontWeight: 700, background: 'transparent', color: textColor, fontFamily: 'Plus Jakarta Sans, sans-serif', letterSpacing: '-.2px' }} />
          <span className="kbd">ESC</span>
        </div>
        {/* Results */}
        <div style={{ maxHeight: 380, overflowY: 'auto' }}>
          {results.length === 0
            ? <div style={{ padding: '32px 18px', textAlign: 'center', color: subColor, fontSize: 14 }}>Không tìm thấy kết quả nào</div>
            : results.map((r, i) => (
              <div key={r.key} className={`search-result-item${i === selected ? ' selected' : ''}`}
                onClick={() => { navigate(r.key); onClose(); }}
                onMouseEnter={() => setSelected(i)}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: i === selected ? `linear-gradient(135deg,${D.indigo}22,${D.purple}14)` : (isDarkMode ? 'rgba(255,255,255,.06)' : '#f1f5f9'), display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: i === selected ? D.indigo : subColor, fontSize: 16, transition: 'all .15s' }}>
                  {r.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: textColor }}>{r.label}</div>
                  <div style={{ fontSize: 11, color: subColor, fontFamily: 'JetBrains Mono, monospace' }}>{r.key}</div>
                </div>
                {i === selected && <span className="kbd">↵</span>}
              </div>
            ))
          }
        </div>
        <div className="search-footer">
          {[['↑↓','Điều hướng'],['↵','Mở trang'],['ESC','Đóng']].map(([k,l]) => (
            <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: subColor }}>
              <span className="kbd">{k}</span><span>{l}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── SIDEBAR CONTENT ─────────────────────────────────────────────────────────
function SidebarContent({ collapsed, userRoles, location, onItemClick }) {
  const [collapsedGroups, setCollapsedGroups] = useState(() => new Set()); // tên nhóm đang bị THU GỌN — mặc định mở hết
  const toggleGroup = (sectionName) => {
    setCollapsedGroups(prev => {
      const next = new Set(prev);
      if (next.has(sectionName)) next.delete(sectionName); else next.add(sectionName);
      return next;
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="sidebar-scroll" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingBottom: 8 }}>
        {MENU_GROUPS.map((group, gi) => {
          const visibleItems = group.items.filter(item =>
            item.roles.some(r => userRoles.includes(r)) ||
            (userRoles.includes('coordinator') && item.roles.includes('admin') && item.key !== '/subjects')
          );
          if (visibleItems.length === 0) return null;
          const isGroupCollapsed = collapsedGroups.has(group.section);
          const hasActiveItem = visibleItems.some(item => item.key === location.pathname);
          return (
            <div key={gi}>
              {!collapsed ? (
                <div className={`nav-section-label${gi === 0 ? ' first' : ''}${isGroupCollapsed ? ' is-collapsed' : ''}`} onClick={() => toggleGroup(group.section)}>
                  <span className="nav-section-chevron"><RightOutlined /></span>
                  {group.sectionIcon && <span className="nav-section-icon">{group.sectionIcon}</span>}
                  <span>{group.section}</span>
                  {isGroupCollapsed && hasActiveItem && <span className="nav-section-dot" />}
                </div>
              ) : (
                gi > 0 && <div className="nav-section-divider" />
              )}
              <div className={`nav-group-body${(!collapsed && isGroupCollapsed) ? ' collapsed' : ''}`}>
                <Menu theme="dark" mode="inline" inlineCollapsed={collapsed}
                  selectedKeys={[location.pathname]} className="et-menu" onClick={onItemClick}
                  items={visibleItems.map(item => ({
                    key: item.key,
                    icon: collapsed
                      ? <Tooltip title={item.label} placement="right"><span>{item.icon}</span></Tooltip>
                      : item.icon,
                    label: collapsed ? null : <Link to={item.key}>{item.label}</Link>,
                    onClick: onItemClick,
                  }))}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── NOTIFICATION BELL COMPONENT ───────────────────────────────────────────
const NotificationBell = ({ userId }) => {
    const [open, setOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        if (!userId) return;
        const q = query(
            collection(db, COLLECTIONS.NOTIFICATIONS),
            where('receiverId', '==', userId),
            orderBy('createdAt', 'desc')
        );
        const unsub = onSnapshot(q, (snap) => {
            setNotifications(snap.docs.map(d => ({ key: d.id, ...d.data() })));
        });
        return () => unsub();
    }, [userId]);

    const unreadCount = notifications.filter(n => !n.isRead).length;

    const filtered = filter === 'unread' ? notifications.filter(n => !n.isRead) : notifications;

    const markAsRead = async (id) => {
        try {
            await updateDoc(doc(db, COLLECTIONS.NOTIFICATIONS, id), { isRead: true });
        } catch (err) { console.error(err); }
    };

    const markAllRead = async () => {
        try {
            const unread = notifications.filter(n => !n.isRead);
            await Promise.all(unread.map(n => updateDoc(doc(db, COLLECTIONS.NOTIFICATIONS, n.key), { isRead: true })));
        } catch (err) { console.error(err); }
    };

    const deleteNotification = async (id) => {
        try {
            await deleteDoc(doc(db, COLLECTIONS.NOTIFICATIONS, id));
        } catch (err) { console.error(err); }
    };

    const getTypeConfig = (type) => NOTIF_TYPE_CONFIG[type] || NOTIF_TYPE_CONFIG.info;
    const getTypeIcon = (type) => getTypeConfig(type).icon;

    const fmtTime = (ts) => {
        if (!ts) return '';
        const d = ts?.toDate ? ts.toDate() : new Date(ts);
        const now = new Date();
        const diff = (now - d) / 1000;
        if (diff < 60) return 'vừa xong';
        if (diff < 3600) return `${Math.floor(diff / 60)} phút trước`;
        if (diff < 86400) return `${Math.floor(diff / 3600)} giờ trước`;
        return `${Math.floor(diff / 86400)} ngày trước`;
    };

    return (
        <>
            <Tooltip title="Thông báo" placement="bottom">
                <button
                    className="et-icon-btn"
                    onClick={() => setOpen(true)}
                    style={{ border: 'none', cursor: 'pointer', position: 'relative' }}
                >
                    <Badge count={unreadCount} size="small" offset={[-2, 2]}>
                        <BellOutlined />
                    </Badge>
                </button>
            </Tooltip>

            <Drawer
                title={
                    <div style={{ padding: '8px 0' }}>
                        <Text strong style={{ fontSize: 18 }}>Thông báo</Text>
                        <br />
                        <Text type="secondary" style={{ fontSize: 13 }}>
                            {unreadCount > 0 ? `${unreadCount} chưa đọc · ${notifications.length} tổng` : `${notifications.length} thông báo`}
                        </Text>
                    </div>
                }
                placement="right"
                width={400}
                onClose={() => setOpen(false)}
                open={open}
                footer={
                    <div style={{ padding: '12px 0', display: 'flex', gap: 10 }}>
                        <Button onClick={() => setOpen(false)} style={{ flex: 1, height: 40, borderRadius: 12 }}>
                            Đóng
                        </Button>
                        <Button type="primary" onClick={markAllRead} disabled={unreadCount === 0}
                            style={{ flex: 1, height: 40, borderRadius: 12, background: '#6366f1' }}>
                            Xem tất cả
                        </Button>
                    </div>
                }
            >
                <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                    <button onClick={() => setFilter('all')} style={{
                        flex: 1, height: 36, borderRadius: 18, border: 'none',
                        background: filter === 'all' ? '#6366f1' : '#f1f5f9',
                        color: filter === 'all' ? '#fff' : '#64748b',
                        fontWeight: 600, fontSize: 13, cursor: 'pointer',
                        transition: 'all 0.2s',
                    }}>
                        Tất cả
                    </button>
                    <button onClick={() => setFilter('unread')} style={{
                        flex: 1, height: 36, borderRadius: 18, border: 'none',
                        background: filter === 'unread' ? '#6366f1' : '#f1f5f9',
                        color: filter === 'unread' ? '#fff' : '#64748b',
                        fontWeight: 600, fontSize: 13, cursor: 'pointer',
                        transition: 'all 0.2s',
                    }}>
                        Chưa đọc ({unreadCount})
                    </button>
                </div>

                {filtered.length === 0 ? (
                    <Empty description="Không có thông báo" style={{ marginTop: 60 }} />
                ) : (
                    <List
                        dataSource={filtered}
                        renderItem={(item) => {
                            const cfg = getTypeConfig(item.type);
                            return (
                                <div
                                    onClick={() => !item.isRead && markAsRead(item.key)}
                                    style={{
                                        display: 'flex',
                                        gap: 12,
                                        padding: '14px 0',
                                        borderBottom: '1px solid #f1f5f9',
                                        cursor: 'pointer',
                                        opacity: item.isRead ? 0.6 : 1,
                                        transition: 'opacity 0.2s',
                                    }}
                                >
                                    <div style={{
                                        width: 40, height: 40, borderRadius: 10,
                                        background: cfg.bg,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: cfg.color, fontSize: 18, flexShrink: 0,
                                    }}>
                                        {cfg.icon}
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
                                            <Text strong style={{ fontSize: 14, color: '#0f172a', lineHeight: 1.4 }}>
                                                {item.title}
                                            </Text>
                                            <Button type="text" size="small" icon={<DeleteOutlined />}
                                                style={{ color: '#94a3b8', flexShrink: 0 }}
                                                onClick={(e) => { e.stopPropagation(); deleteNotification(item.key); }}
                                            />
                                        </div>
                                        <Text style={{ fontSize: 13, color: '#64748b', display: 'block', marginTop: 2, lineHeight: 1.5 }}>
                                            {item.message || item.body}
                                        </Text>
                                        <Text style={{ fontSize: 12, color: '#94a3b8', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}>
                                            <ClockCircleOutlined style={{ fontSize: 11 }} /> {fmtTime(item.createdAt)}
                                        </Text>
                                    </div>
                                </div>
                            );
                        }}
                    />
                )}
            </Drawer>
        </>
    );
};

// ─── MAIN LAYOUT ─────────────────────────────────────────────────────────────
function MainLayout({ isDarkMode, toggleTheme }) {
  const screens     = useBreakpoint();
  const isMobile    = !screens.lg;
  const location    = useLocation();
  const navigate    = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const { userData } = useAuth();
  const userRoles = getRoles(userData?.firestore); // 1 người có thể có nhiều vai trò
  const userRole  = getPrimaryRole(userData?.firestore); // vai trò "chính" — chỉ dùng khi cần hiện 1 nhãn duy nhất
  const userId    = userData?.auth?.uid;

  // Ghi nhận lượt ra/vào web — 1 session khi mở app, 1 page_view mỗi lần đổi trang
  usePageTracking({
      userId, userName: userData?.firestore?.displayName || userData?.auth?.displayName,
      role: userRole, pathname: location.pathname, pageLabel: ROUTE_META[location.pathname]?.label,
  });

  const [collapsed,        setCollapsed]        = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [searchOpen,       setSearchOpen]       = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [confirmLoading,   setConfirmLoading]   = useState(false);
  const [popupNotifs, setPopupNotifs] = useState([]);

  // Subscribe notifications for popup
  useEffect(() => {
    if (!userId) return;
    const q = query(
      collection(db, COLLECTIONS.NOTIFICATIONS),
      where('receiverId', '==', userId),
      orderBy('createdAt', 'desc')
    );
    const unsub = onSnapshot(q, (snap) => {
      const notifs = snap.docs.map(d => ({ key: d.id, ...d.data() }));
      
      setPopupNotifs(notifs);
    }, (err) => {
      console.error('Lỗi notifications:', err);
    });
    return () => unsub();
  }, [userId]);

  const siderWidth    = 228;
  const siderCollapse = 64;
  const contentMargin = isMobile ? 0 : (collapsed ? siderCollapse : siderWidth);

  // Close mobile drawer on route change
  useEffect(() => { setMobileDrawerOpen(false); }, [location]);

  // Force password change
  useEffect(() => {
    if (userData?.firestore?.forcePasswordChange === true) setIsPasswordModalOpen(true);
  }, [userData]);

  // Keyboard shortcuts
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); setSearchOpen(s => !s); }
      if (e.key === 'Escape') { setSearchOpen(false); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  const handleChangePassword = async () => {
    try {
      const values = await form.validateFields();
      if (values.newPassword !== values.confirmPassword) { messageApi.error('Mật khẩu không khớp!'); return; }
      setConfirmLoading(true);
      await updatePassword(auth.currentUser, values.newPassword);
      await updateDoc(doc(db, 'users', auth.currentUser.uid), { forcePasswordChange: false });
      setConfirmLoading(false); setIsPasswordModalOpen(false); form.resetFields();
      messageApi.success('Đổi mật khẩu thành công!');
      await signOut(auth);
    } catch (e) { messageApi.error('Lỗi: ' + e.message); setConfirmLoading(false); }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  const breadcrumbs = useMemo(() => {
    const meta = ROUTE_META[location.pathname];
    if (!meta) return [];
    return [
      { title: <HomeOutlined style={{ fontSize: 12 }} />, href: ['student','parent'].includes(userRole) ? '/student-dashboard' : '/' },
      { title: <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>{React.cloneElement(meta.icon, { style: { fontSize: 11 } })}{meta.label}</span> },
    ];
  }, [location.pathname, userRole]);

  const currentMeta = ROUTE_META[location.pathname];
  const roleInfo    = ROLE_LABELS[userRole] || {};

  const bottomNavItems = useMemo(() => {
    const pool = ['student','parent'].includes(userRole) ? BOTTOM_NAV_ITEMS_STUDENT : BOTTOM_NAV_ITEMS_TEACHER;
    return pool.filter(i => i.roles.includes(userRole) || (userRole === 'coordinator' && i.roles.includes('admin')));
  }, [userRole]);

  // ── User dropdown ────────────────────────────────────────────────────────
  const userMenuItems = [
    {
      key: 'user-info',
      label: (
        <div style={{ padding: '6px 4px 8px', pointerEvents: 'none' }}>
          <div style={{ fontWeight: 800, fontSize: 14, color: isDarkMode ? '#f1f5f9' : '#0f172a', marginBottom: 4 }}>
            {userData?.firestore?.displayName || 'User'}
          </div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 20, background: roleInfo.bg, color: roleInfo.color, fontWeight: 800, fontSize: 11 }}>
            <span>{roleInfo.icon}</span>{roleInfo.label}
          </div>
          <div style={{ fontSize: 11, color: isDarkMode ? '#475569' : '#94a3b8', marginTop: 5, fontFamily: 'JetBrains Mono, monospace' }}>
            {userData?.auth?.email}
          </div>
        </div>
      ),
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'profile',
      icon: <UserOutlined style={{ color: isDarkMode ? '#94a3b8' : '#64748b' }} />,
      label: <Link to="/profile" style={{ color: isDarkMode ? '#cbd5e1' : '#334155', fontWeight: 600 }}>Hồ sơ cá nhân</Link>,
    },
    {
      key: 'search',
      icon: <SearchOutlined style={{ color: isDarkMode ? '#94a3b8' : '#64748b' }} />,
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 600, color: isDarkMode ? '#cbd5e1' : '#334155' }}>
          <span>Tìm kiếm nhanh</span>
          <div style={{ display: 'flex', gap: 3 }}>
            <span className="kbd">{navigator.platform?.includes('Mac') ? '⌘' : 'Ctrl'}</span>
            <span className="kbd">K</span>
          </div>
        </div>
      ),
      onClick: () => setSearchOpen(true),
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined style={{ color: '#ef4444' }} />,
      label: <span style={{ color: '#ef4444', fontWeight: 700 }}>Đăng xuất</span>,
      onClick: handleLogout,
    },
  ];

  // ── Sidebar user block (collapsed → just avatar) ──────────────────────
  const SidebarUserBlock = () => (
    <div className="sidebar-footer">
      <Dropdown menu={{ items: userMenuItems, className: 'et-user-menu' }} trigger={['click']} placement="topLeft" overlayStyle={{ minWidth: 220 }}>
        <div className="sidebar-footer-inner">
          <Avatar src={userData?.firestore?.photoURL} icon={<UserOutlined />} size={36}
            style={{ background: `linear-gradient(135deg,${D.indigo},${D.purple})`, border: '2px solid rgba(255,255,255,.15)', flexShrink: 0 }} />
          {!collapsed && (
            <>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: '#e2e8f0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {userData?.firestore?.displayName || 'User'}
                </div>
                <div style={{ fontSize: 11, color: roleInfo.color || '#64748b', fontWeight: 700 }}>{roleInfo.icon} {roleInfo.label}</div>
              </div>
              <DownOutlined style={{ fontSize: 10, color: '#475569', flexShrink: 0 }} />
            </>
          )}
        </div>
      </Dropdown>
    </div>
  );

  // ── Page activity indicator (NEW F4) ──────────────────────────────────
  const PageTitle = () => {
    const label = currentMeta?.label || 'EduTrack';
    const icon  = currentMeta?.icon;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Breadcrumb items={breadcrumbs} className="et-breadcrumb" />
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
          {icon && React.cloneElement(icon, { style: { fontSize: 14, color: D.indigo } })}
          <Title level={5} style={{ margin: 0, color: isDarkMode ? '#f1f5f9' : '#0f172a', fontWeight: 900, letterSpacing: '-.35px', lineHeight: 1 }}>
            {label}
          </Title>
        </div>
      </div>
    );
  };

  return (
    <>
      {contextHolder}
      <style dangerouslySetInnerHTML={{ __html: buildCSS(isDarkMode) }} />

      {/* NEW F1: Search Spotlight */}
      <SearchSpotlight open={searchOpen} onClose={() => setSearchOpen(false)} userRoles={userRoles} navigate={navigate} isDarkMode={isDarkMode} />

      {/* Notification Popup Modal - bắt buộc đọc */}
      <NotificationPopupModal notifications={popupNotifs} caseConfigs={NOTIF_CASE_CONFIG} />

      <Layout className={userRoles.some(r => ['student', 'parent'].includes(r)) && !userRoles.some(r => ['admin', 'teacher', 'coordinator'].includes(r)) ? 'student-shell' : undefined} style={{ minHeight: '100vh', background: isDarkMode ? '#0a0a1a' : '#fff', '--page-surface': isDarkMode ? '#0a0a1a' : '#fff', position: 'relative', overflow: 'hidden' }}>
        {isDarkMode && (
          <>
            <div style={{ position: 'fixed', top: '-20%', right: '-10%', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,0.12) 0%, transparent 70%)', filter: 'blur(80px)', pointerEvents: 'none', zIndex: 0 }} />
            <div style={{ position: 'fixed', bottom: '-15%', left: '-5%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 70%)', filter: 'blur(80px)', pointerEvents: 'none', zIndex: 0 }} />
          </>
        )}

        {/* ── DESKTOP SIDEBAR ──────────────────────────────────── */}
        {!isMobile && (
          <>
            <Sider width={siderWidth} collapsedWidth={siderCollapse} collapsed={collapsed}
              className="et-sidebar lg-scrollbar"
              style={{
                position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 100, overflow: 'visible',
                display: 'flex', flexDirection: 'column', height: '100vh',
                background: isDarkMode
                  ? 'rgba(10, 10, 30, 0.75)'
                  : D.sidebarBg,
                backdropFilter: isDarkMode ? 'blur(20px) saturate(180%)' : undefined,
                WebkitBackdropFilter: isDarkMode ? 'blur(20px) saturate(180%)' : undefined,
                borderRight: isDarkMode ? '1px solid rgba(255,255,255,0.08)' : 'none',
                boxShadow: isDarkMode ? '2px 0 40px rgba(0,0,0,0.4), inset -1px 0 0 rgba(255,255,255,0.05)' : '2px 0 32px rgba(0,0,0,.28)',
              }}>
              <div className="et-sidebar-breathe" style={{ position: 'absolute', top: -60, left: '10%', width: 260, height: 260, borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,.13) 0%, transparent 70%)', pointerEvents: 'none' }} />
              <div style={{ position: 'absolute', top: 0, right: 0, bottom: 0, width: 1, background: 'linear-gradient(180deg, transparent 0%, rgba(129,140,248,.35) 20%, rgba(139,92,246,.3) 55%, rgba(129,140,248,.25) 80%, transparent 100%)', pointerEvents: 'none' }} />

              {/* Logo — nền có hiệu ứng phát sáng nhẹ phía sau */}
              <div style={{ padding: '18px 0 15px', borderBottom: `1px solid ${D.sidebarBorder}`, flexShrink: 0, position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: -30, left: '50%', transform: 'translateX(-50%)', width: 140, height: 90, background: 'radial-gradient(ellipse, rgba(129,140,248,0.28) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div style={{ position: 'relative' }}>
                  <AiLogo collapsed={collapsed} />
                </div>
              </div>

              {/* Nav — flex: 1, scroll nếu dài */}
              <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }} className="sidebar-scroll">
                <SidebarContent collapsed={collapsed} userRoles={userRoles} location={location} onItemClick={() => {}} />
              </div>
            </Sider>

            {/* Nút thu gọn — đặt NGOÀI Sider (Sider có overflow:hidden nên nút tràn viền -13px sẽ bị cắt mất nửa nếu để bên trong) */}
            <div className="et-collapse-btn" style={{ left: (collapsed ? siderCollapse : siderWidth) - 13 }} onClick={() => setCollapsed(c => !c)}>
              {collapsed ? <RightOutlined /> : <LeftOutlined />}
            </div>
          </>
        )}

        {/* ── MOBILE DRAWER ────────────────────────────────────── */}
        {isMobile && (
          <Drawer placement="left" open={mobileDrawerOpen} onClose={() => setMobileDrawerOpen(false)}
            width={268} className="et-mobile-drawer" title={<AiLogo collapsed={false} />}
            styles={{ body: { padding: 0, background: 'linear-gradient(168deg,#080f1e 0%,#0c1628 100%)', display: 'flex', flexDirection: 'column' } }}>
            <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }} className="sidebar-scroll">
              <SidebarContent collapsed={false} userRoles={userRoles} location={location} onItemClick={() => setMobileDrawerOpen(false)} />
            </div>
            <div style={{ padding: '10px 12px', borderTop: '1px solid rgba(255,255,255,.06)', background: 'rgba(0,0,0,.2)', flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px' }}>
                <Avatar src={userData?.firestore?.photoURL} icon={<UserOutlined />} size={34}
                  style={{ background: `linear-gradient(135deg,${D.indigo},${D.purple})`, border: '2px solid rgba(255,255,255,.15)', flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: '#e2e8f0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{userData?.firestore?.displayName}</div>
                  <div style={{ fontSize: 11, color: roleInfo.color, fontWeight: 700 }}>{roleInfo.label}</div>
                </div>
                <Button type="text" size="small" icon={<LogoutOutlined />} onClick={handleLogout}
                  style={{ color: '#ef4444', background: 'rgba(239,68,68,.1)', borderRadius: 8, width: 32, height: 32, border: 'none' }} />
              </div>
            </div>
          </Drawer>
        )}

        {/* ── MAIN CONTENT ─────────────────────────────────────── */}
        <Layout className="et-content-layout" style={{ marginLeft: contentMargin, background: 'transparent', minHeight: '100vh' }}>

          {/* HEADER */}
          <Header className="et-header">
            {/* Left */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
              {isMobile && (
                <button onClick={() => setMobileDrawerOpen(true)} className="et-icon-btn" style={{ border: 'none', cursor: 'pointer', flexShrink: 0 }}>
                  <MenuOutlined />
                </button>
              )}
              {isMobile
                ? <Title level={5} style={{ margin: 0, color: isDarkMode ? '#f1f5f9' : '#0f172a', fontWeight: 900, letterSpacing: '-.3px' }}>{currentMeta?.label || 'EduTrack'}</Title>
                : <PageTitle />
              }
            </div>

            {/* Right actions */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexShrink: 0 }}>
              {/* NEW F1: Search button */}
              <Tooltip title={<span>Tìm kiếm <kbd className="kbd" style={{ marginLeft: 4 }}>⌘K</kbd></span>} placement="bottom">
                <button className="et-icon-btn" onClick={() => setSearchOpen(true)} style={{ border: 'none', cursor: 'pointer' }}>
                  <SearchOutlined />
                </button>
              </Tooltip>

              {/* Notification Bell */}
              <NotificationBell userId={userId} />

              {/* Profile pill — desktop */}
              {!isMobile && (
                <Dropdown menu={{ items: userMenuItems, className: 'et-user-menu' }} trigger={['click']} placement="bottomRight" overlayStyle={{ minWidth: 230 }}>
                  <div className="et-profile-pill">
                    <div style={{ position: 'relative', flexShrink: 0 }}>
                      <Avatar src={userData?.firestore?.photoURL} icon={<UserOutlined />} size={32}
                        style={{ background: `linear-gradient(135deg,${D.indigo},${D.purple})`, border: '2px solid rgba(99,102,241,.35)', display: 'block' }} />
                      <div className="online-dot" style={{ position: 'absolute', bottom: -1, right: -1, width: 9, height: 9, border: `2px solid ${isDarkMode ? '#07101e' : '#fff'}` }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25, maxWidth: 180 }}>
                      <span style={{ fontWeight: 700, color: isDarkMode ? '#e2e8f0' : '#111827', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {userData?.firestore?.displayName || 'User'}
                      </span>
                      <span style={{ fontSize: 10.5, fontWeight: 600, color: D.indigo, opacity: .85 }}>
                        {ROLE_LABELS[userRoles?.[0]]?.label || userRoles?.[0] || 'Thành viên'}
                      </span>
                    </div>
                    <DownOutlined style={{ fontSize: 9, color: isDarkMode ? '#3d4f6b' : '#9ca3af' }} />
                  </div>
                </Dropdown>
              )}

              {/* Mobile: avatar */}
              {isMobile && (
                <Dropdown menu={{ items: userMenuItems, className: 'et-user-menu' }} trigger={['click']} placement="bottomRight">
                  <Avatar src={userData?.firestore?.photoURL} icon={<UserOutlined />} size={36}
                    style={{ background: `linear-gradient(135deg,${D.indigo},${D.purple})`, border: '2px solid rgba(99,102,241,.25)', cursor: 'pointer', flexShrink: 0 }} />
                </Dropdown>
              )}
            </div>
          </Header>

          {/* PAGE CONTENT */}
          <Content className={`et-content-inner${!isDarkMode ? ' et-light-pages' : ''}`} style={{ background: 'transparent', overflowX: 'hidden' }}>
            <Outlet />
          </Content>
        </Layout>

        {/* MOBILE BOTTOM NAV */}
        {isMobile && (
          <nav className="et-bottom-nav">
            {bottomNavItems.slice(0, 5).map(item => {
              const isActive = location.pathname === item.key;
              return (
                <Link key={item.key} to={item.key} className={`et-bottom-nav-item${isActive ? ' active' : ''}`}>
                  <span className="nav-icon">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>
        )}
      </Layout>

      {/* PASSWORD MODAL */}
      <Modal className="et-pw-modal"
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ background: '#fee2e2', width: 42, height: 42, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <LockOutlined style={{ color: '#ef4444', fontSize: 20 }} />
            </div>
            <div>
              <div style={{ fontSize: 16, fontWeight: 900, color: isDarkMode ? '#f1f5f9' : '#0f172a' }}>Đổi mật khẩu bắt buộc</div>
              <div style={{ fontSize: 12, color: isDarkMode ? '#64748b' : '#94a3b8', fontWeight: 500, marginTop: 2 }}>Tài khoản yêu cầu đặt mật khẩu mới</div>
            </div>
          </div>
        }
        open={isPasswordModalOpen} confirmLoading={confirmLoading}
        onOk={handleChangePassword} closable={false} maskClosable={false} keyboard={false}
        cancelButtonProps={{ style: { display: 'none' } }} okText="Cập nhật mật khẩu"
        okButtonProps={{ style: { borderRadius: 10, background: `linear-gradient(135deg,${D.indigo},${D.purple})`, border: 'none', height: 42, fontWeight: 700, padding: '0 28px' } }}
        centered width={440}>
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="newPassword" label={<Text strong style={{ color: isDarkMode ? '#94a3b8' : '#475569' }}>Mật khẩu mới</Text>}
            rules={[{ required: true, message: 'Nhập mật khẩu mới' },{ min: 6, message: 'Ít nhất 6 ký tự' }]}>
            <Input.Password size="large" style={{ borderRadius: 10 }} placeholder="Tối thiểu 6 ký tự" />
          </Form.Item>
          <Form.Item name="confirmPassword" label={<Text strong style={{ color: isDarkMode ? '#94a3b8' : '#475569' }}>Xác nhận mật khẩu</Text>}
            rules={[{ required: true, message: 'Xác nhận lại mật khẩu' }]}>
            <Input.Password size="large" style={{ borderRadius: 10 }} placeholder="Nhập lại mật khẩu mới" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default MainLayout;